<template>
  <div class="row">
    <div class="col-xs-12 col-sm-12 col-md-8 col-lg-8 outer-box">
      <div class="innerBox" style="height: 100%">
        <h2 style="text-align: center; font-weight: 700">Top 10 Sales By Dealer</h2>
        <div ref="salesByDealer" style="height: 480px"></div>
      </div>
    </div>
    <div class="col-xs-12 col-sm-12 col-md-4 col-lg-4 outer-box">
      <div class="innerBox" style="height: 565px; overflow: auto;">
        <h3 style="text-align: center; font-weight: 700">Sales By Dealer</h3>
        <table class="table table-striped" v-if="data">
          <thead>
            <tr>
              <th>#</th>
              <th>Dealer</th>
              <th>Qty</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(salesData, index) in data" :key="salesData.dealer">
              <td>{{index + 1}}</td>
              <td>{{salesData.dealer}}</td>
              <td style="color: green;">{{numberWithCommas(salesData.sold)}}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
  import * as am4core from '@amcharts/amcharts4/core'
  import * as am4charts from '@amcharts/amcharts4/charts'
  import am4themesAnimated from '@amcharts/amcharts4/themes/animated'

  export default {
    data () {
      return {
        data : null,
        chart : null,
      }
    },
    props : ['filterUrl'],
    mounted () {
      this.createChart()
    },
    watch : {
      filterUrl(){
        this.fetchData()
      }
    },
    methods : {
      fetchData () {
        var length = this.chart.data.length;
        this.$http.get('/api/h1/retail-sales/top-ten-by-dealer?' + this.filterUrl)
        .then((resp)=>{
          var data = resp.data.data
          data = (data != null && data.length != 0) ? data : [{dealer : 'No Data', sold : 1}];

          this.data = data;
          this.chart.addData(data, length);
        })
        .catch((err)=>{
          console.log(err);
        })
      },
      createChart () {
        /* Chart code */
        // Themes begin
        am4core.useTheme(am4themesAnimated)
        // Themes end

        // Create chart instance
        this.chart = am4core.create(this.$refs.salesByDealer, am4charts.PieChart)

        // Add and configure Series
        let pieSeries = this.chart.series.push(new am4charts.PieSeries())
        pieSeries.dataFields.value = 'sold'
        pieSeries.dataFields.category = 'dealer'

        // Let's cut a hole in our Pie chart the size of 30% the radius
        this.chart.innerRadius = am4core.percent(30)

        // Put a thick white border around each Slice
        pieSeries.slices.template.stroke = am4core.color('#fff')
        pieSeries.slices.template.strokeWidth = 2
        pieSeries.slices.template.strokeOpacity = 1
        pieSeries.slices.template
          // change the cursor on hover to make it apparent the object can be interacted with
          .cursorOverStyle = [
            {
              'property': 'cursor',
              'value': 'pointer'
            }
          ]

        // pieSeries.alignLabels = false
        // pieSeries.labels.template.bent = true
        // pieSeries.labels.template.radius = 3
        // pieSeries.labels.template.padding(0, 0, 0, 0)

        // pieSeries.ticks.template.disabled = true

        // Create a base filter effect (as if it's not there) for the hover to return to
        let shadow = pieSeries.slices.template.filters.push(new am4core.DropShadowFilter())
        shadow.opacity = 0

        // Create hover state
        let hoverState = pieSeries.slices.template.states.getKey('hover') // normally we have to create the hover state, in this case it already exists

        // Slightly shift the shadow and make it more prominent on hover
        let hoverShadow = hoverState.filters.push(new am4core.DropShadowFilter())
        hoverShadow.opacity = 0.7
        hoverShadow.blur = 5

        // Add a legend
        this.chart.legend = new am4charts.Legend()
      }
    }
  }
</script>